import CaseLeftSideHeader from "components/CaseLeftSideHeader";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import CaseRightSideHeader from "components/CaseRightSideHeader";
import { useContext } from "react";
import CasesContext from "contexts/CasesContext";
import { useMediaQuery } from "usehooks-ts";
import BackIcon from "assets/icons/back.svg?react";
import { useNavigate } from "react-router-dom";

const CaseHeader: FC<Props> = ({ hideOptions, Case, optionsRef, statuses }) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const { cases } = useContext(CasesContext);

  const navigate = useNavigate();

  const caseContext = cases.find((c) => c.Id === Case?.Id) ?? Case;

  const handleMobileBack = () => {
    navigate("/cases");
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        {isMobile && (
          <div className={styles.tools}>
            <div className={styles.backButton}>
              <BackIcon onClick={() => handleMobileBack()}></BackIcon>
            </div>
          </div>
        )}
        {caseContext && <CaseLeftSideHeader Case={caseContext} />}
      </div>
      <div className={styles.right}>
        {caseContext && (
          <CaseRightSideHeader
            hideOptions={hideOptions}
            optionsRef={optionsRef}
            Case={caseContext}
            statuses={statuses}
          />
        )}
      </div>
    </div>
  );
};

export default CaseHeader;
